import { render, staticRenderFns } from "./AddressActivity.vue?vue&type=template&id=182267ec&scoped=true&"
import script from "./AddressActivity.vue?vue&type=script&lang=js&"
export * from "./AddressActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182267ec",
  null
  
)

export default component.exports